module.exports = __webpack_public_path__ + "static/img/shengluetu.081f4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shengluetu.png
// module id = 9sWp
// module chunks = 1